<div class="d-flex">
  <div class="flex-0-2">
    Afdeling
  </div>
  <div class="flex-0-22">
    Verantwoordelijke
  </div>
  <div class="flex-0-2">
    Telefoon
  </div>
  <div class="flexer">
    E-mail
  </div>
</div>
<div
  *ngFor="let worker of workers; let first = first"
  class="d-flex"
  [ngClass]="first ? 'upper-space' : 'smaller-upper-space'"
>
  <div class="flex-0-2 strong secondary-color">
    {{ worker.department }}
  </div>
  <div class="flex-0-22">
    <div class="d-flex">
      <div class="rounded-circle employee-initials">
        <span
          *ngIf="worker.profilePictureUrl == null"
          class="initials-text rounded-circle in-the-middle no-margin"
        >
          {{ worker.initials }}
        </span>

        <span
          *ngIf="worker.profilePictureUrl != null"
          class="in-the-middle rounded-circle"
        >
          <img
            class="rounded-circle"
            width="30px"
            height="30px"
            src="{{ worker.profilePictureUrl }}"
          />
        </span>
      </div>
      <div class="strong small-left-space">
        {{ worker.name }}
      </div>
    </div>
  </div>
  <div class="flex-0-2">
    {{ worker.phoneNumber }}
  </div>
  <div class="flexer">
    <a href="mailto:{{ worker.displayEmailAddress }}">{{
      worker.displayEmailAddress
    }}</a>
  </div>
</div>
